export const TELSYS_FILTER_NAME: string = 'telsys'
export const PARTITION_FILTER_NAME: string = 'partition'
